import * as yup from 'yup'

import {
  configurationsFields as CF,
  configRootFields,
  ERP_FIELDS,
} from 'components/configuration/utils'
import { EMAIL_REGEX, HOST_REGEX, MULTIPLE_EMAIL_REGEX } from 'utils/constants'

const NUMBER_REGEX = /^([1-9][0-9]*)$/

const arrayOfStringSchema = yup.array().of(yup.string()).optional()

const lastMileLoginextSchema = yup.object().shape({
  [CF.LAST_MILE_ORDER_CREATE.key]: yup
    .string()
    .trim()
    .required('End Point is a required field'),
  [CF.LAST_MILE_ORDER_UPDATE.key]: yup
    .string()
    .trim()
    .required('End Point is a required field'),
  [CF.LAST_MILE_ORDER_CANCEL.key]: yup
    .string()
    .trim()
    .required('End Point is a required field'),
  [CF.LAST_MILE_ORDER_UPDATE_CREATES.key]: yup
    .string()
    .trim()
    .required('End Point is a required field'),
  [CF.LAST_MILE_TOKEN.key]: yup
    .string()
    .trim()
    .required('Bearer Token is a required field'),
})

const erpSchema = yup.object().shape({
  [ERP_FIELDS.URL]: yup
    .string()
    .trim()
    .required('End Point is a required field'),
  [ERP_FIELDS.USERNAME]: yup
    .string()
    .trim()
    .required('Username is a required field'),
  [ERP_FIELDS.PASSWORD]: yup
    .string()
    .trim()
    .required('Password is a required field'),
})

const sapErpSchema = yup.object().shape({
  [ERP_FIELDS.URL]: yup
    .string()
    .trim()
    .required('End Point is a required field'),
  // TODO: implement enable/disable functionality in future
  // [ERP_FIELDS.IS_ENABLED]: yup
  //   .string()
  //   .trim()
  //   .required('Status is a required field'),
})

export const configurationSchema = yup
  .object()
  .shape({
    // // ERP - MASTER
    // [configRootFields.ERP_MASTER]: erpSchema,
    // // ERP - INVENTORY
    // [configRootFields.ERP_INVENTORY]: erpSchema,
    // // ERP - PRICING
    // [configRootFields.ERP_PRICING]: erpSchema,
    // // ERP - ORDER Create
    // [configRootFields.ERP_ORDER_CREATE]: erpSchema,
    // // ERP - Reconciliation
    // [configRootFields.ERP_RECONCILIATION]: erpSchema,
    // ERP - Last Mile
    [configRootFields.LAST_MILE]: lastMileLoginextSchema,
    // ERP - Block Sale on POS
    // [configRootFields.BLOCK_SALE_POS]: erpSchema,
    // Fresh System
    [configRootFields.FRESH]: erpSchema,

    [configRootFields.SAP_AUTH]: erpSchema,
    [configRootFields.SAP_ERP_ORDER]: sapErpSchema,
    [configRootFields.SAP_ERP_RMA]: sapErpSchema,
    [configRootFields.SAP_ERP_RECONCILIATION]: sapErpSchema,

    // Fresh System
    [configRootFields.RMA_REASON]: arrayOfStringSchema,
    [configRootFields.RMA_CONDITIONS]: arrayOfStringSchema,
    [configRootFields.RMA_REASON_CODE_MAP]: yup
      .object()
      .required('Reason mapping is required')
      .test(
        'all-reasons-mapped',
        'All reasons must have SAP codes',
        function (value: any) {
          const { rmaReasons } = this.parent

          if (!rmaReasons?.length) return true

          return rmaReasons.every(
            (reason: string) =>
              value && value[reason] && value[reason].trim() !== '',
          )
        },
      ),
    [configRootFields.CLUSTERS]: arrayOfStringSchema,
    [CF.DARK_STORES.key]: arrayOfStringSchema,
    [configRootFields.ORDER_TYPES]: arrayOfStringSchema,

    // Cron Expression

    [configRootFields.EXPRESSION]: yup.object().shape({
      [CF.EXPRESSION_MASTER.key]: yup
        .string()
        .trim()
        .required('Master data cron expression is required field'),
      [CF.EXPRESSION_FRESH_MANDATORY_BARCODE_RESET.key]: yup
        .string()
        .trim()
        .required('Fresh mandatory barcode reset cron expression is required'),
      [CF.EXPRESSION_INVENTORY.key]: yup
        .string()
        .trim()
        .required('Inventory cron expression is required field'),
      [CF.EXPRESSION_TEMP_TO_MAIN_PRICING.key]: yup
        .string()
        .trim()
        .required('Temp to main price cron expression is required field'),
      [CF.EXPRESSION_ORDER_SYNC.key]: yup
        .string()
        .trim()
        .required('Order Sync cron expression is required field'),
      [CF.EXPRESSION_LASTMILE_SYNC.key]: yup
        .string()
        .trim()
        .required('Order Lastmile Sync cron expression is required field'),
      [CF.EXPRESSION_RMA_SYNC.key]: yup
        .string()
        .trim()
        .required('Order RMA Sync cron expression is required field'),
      [CF.EXPRESSION_RECONCILIATION.key]: yup
        .string()
        .trim()
        .required('Reconciliation cron expression is required field'),
      [CF.EXPRESSION_EMP_ID.key]: yup
        .string()
        .trim()
        .required('Employee ID cron expression is required field'),
      [CF.EXPRESSION_ERP_COST.key]: yup
        .string()
        .trim()
        .required('ERP Cost expression is required field'),
      [CF.EXPRESSION_TALON_PAYLOAD.key]: yup
        .string()
        .trim()
        .required('Talon cron expression is required field'),
      [CF.EXPRESSION_ECOM_SPECIAL_PRICING.key]: yup
        .string()
        .trim()
        .required('Ecom Special Price cron expression is required field'),
      [CF.EXPRESSION_AGGREGATOR_API.key]: yup
        .string()
        .trim()
        .required('Aggregator API cron expression is required field'),
      [CF.EXPRESSION_PRICING_ERP_TO_TEMP.key]: yup
        .string()
        .trim()
        .required('ERP to temp price cron expression is required field'),
      [CF.EXPRESSION_EXPIRE_SPECIAL_PRICING.key]: yup
        .string()
        .trim()
        .required('Expire Special Price cron expression is required field'),
      [CF.EXPRESSION_MAGENTO_CATALOGUE_SYNC.key]: yup
        .string()
        .trim()
        .required('Magento Catalogue Sync cron expression is required field'),
    }),

    // Invoice
    [configRootFields.INVOICE]: yup.object().shape({
      [CF.INVOICE_REG_NO.key]: yup
        .string()
        .trim()
        .required('VAT Registration Number is a required'),
      [CF.INVOICE_PHONE.key]: yup
        .string()
        .trim()
        .required('Phone Number is a required'),
      [CF.INVOICE_ADDRESS.key]: yup
        .string()
        .trim()
        .required('Address is a required'),
    }),
    // SMTP
    [configRootFields.SMTP]: yup.object().shape({
      [CF.SMTP_HOST.key]: yup
        .string()
        .trim()
        .required('SMTP Host is a required field')
        .matches(HOST_REGEX, 'Please provide valid host'),
      [CF.SMTP_PASSWORD.key]: yup
        .string()
        .trim()
        .required('SMTP Password is a required field'),
      [CF.SMTP_FROM_EMAIL.key]: yup
        .string()
        .trim()
        .required('From Email is a required field')
        .matches(EMAIL_REGEX, 'Please Enter a valid email.'),
      [CF.SMTP_FROM_NAME.key]: yup
        .string()
        .trim()
        .required('From Name is a required field'),
      [CF.SMTP_USERNAME.key]: yup
        .string()
        .trim()
        .required('SMTP Username is a required field'),
    }),
    // SQL
    [configRootFields.SQL]: yup.object().shape({
      [CF.SQL_HOST.key]: yup
        .string()
        .trim()
        .required('SQL Host is a required field')
        .matches(HOST_REGEX, {
          message: 'Please provide valid host',
          excludeEmptyString: true,
        }),
      [CF.SQL_PASSWORD.key]: yup
        .string()
        .trim()
        .required('SQL Password is a required field'),
      [CF.SQL_DATABASE_NAME.key]: yup
        .string()
        .trim()
        .required('SQL Database Name is a required field'),
      [CF.SQL_PORT.key]: yup
        .string()
        .trim()
        .required('SQL Port is a required field')
        .matches(NUMBER_REGEX, {
          message: 'SQL Port must be positive numerical value',
          excludeEmptyString: true,
        }),
      [CF.SMTP_USERNAME.key]: yup
        .string()
        .trim()
        .required('SQL Username is a required field'),
    }),

    // PURCHASE TIMER buffer (flat, top-level field)
    // NOTE: uses /^\d+$/ (not NUMBER_REGEX) so that 0 — the "no buffer"
    // default — is accepted. Optional so it can be left blank.
    [CF.PURCHASE_TIMER_BUFFER.key]: yup
      .string()
      .trim()
      .optional()
      .matches(/^\d+$/, {
        message: 'Buffer time must be a non-negative whole number of minutes.',
        excludeEmptyString: true,
      }),
    // OTHER
    [CF.ADMIN_EMAIL.key]: yup
      .string()
      .trim()
      .required('Admin email is a required field')
      .matches(MULTIPLE_EMAIL_REGEX, 'Please Enter a valid email.'),
    [CF.CS_NUMBER.key]: yup
      .string()
      .trim()
      .required('CS Number is a required field'),
    [CF.FRESH_BARCODE_PREFIX.key]: yup
      .string()
      .trim()
      .optional()
      .test(
        'is-valid-prefix-list',
        'Enter valid comma-separated prefixes',
        (value) => {
          if (!value?.trim()) return true
          const prefixes = value?.split(',').map((p) => p.trim())
          return prefixes.every((p) => /^[a-zA-Z0-9]+$/.test(p))
        },
      ),
    [CF.LOG_DELETION_PERIOD.key]: yup
      .string()
      .trim()
      .required('Log Deletion Period is a required field')
      .matches(
        NUMBER_REGEX,
        'Log Deletion Period must be a positive numerical value.',
      ),
    [CF.MAX_UPLOAD_SIZE.key]: yup
      .string()
      .trim()
      .required('Max Upload Size is a required field')
      .matches(
        NUMBER_REGEX,
        'The maximum upload size must be a positive numerical value.',
      ),
    [CF.MAX_ALLOWED_PRICE_DIFF_PERCENT.key]: yup
      .number()
      .required(
        `${CF.MAX_ALLOWED_PRICE_DIFF_PERCENT.label} is a required field`,
      )
      .typeError(`${CF.MAX_ALLOWED_PRICE_DIFF_PERCENT.label} must be a number`)
      .min(0, 'Minimum value allowed is 0'),
    [CF.MAX_ALLOWED_PRICE_DIFF.key]: yup
      .number()
      .required(`${CF.MAX_ALLOWED_PRICE_DIFF.label} is a required field`)
      .typeError(`${CF.MAX_ALLOWED_PRICE_DIFF.label} must be a number`)
      .min(0, 'Minimum value allowed is 0'),
    [CF.MAX_ALLOWED_TOTAL_PRICE_DIFF_PERCENT.key]: yup
      .number()
      .required(
        `${CF.MAX_ALLOWED_TOTAL_PRICE_DIFF_PERCENT.label} is a required field`,
      )
      .typeError(
        `${CF.MAX_ALLOWED_TOTAL_PRICE_DIFF_PERCENT.label} must be a number`,
      )
      .min(0, 'Minimum value allowed is 0'),
    [CF.MAX_CONCURRENT_AGGREGATORS.key]: yup
      .string()
      .trim()
      .required('Max Concurrent Aggregators is a required field')
      .matches(
        NUMBER_REGEX,
        'The maximum upload size must be a positive numerical value.',
      )
      .test('is-within-range', 'Value must be between 5 and 40', (value) => {
        const num = Number(value)
        return !isNaN(num) && num >= 5 && num <= 40
      })
      .max(40, 'Value must be at most 40'),

    // Third Party FTP
    [configRootFields.THIRD_PARTY_FTP]: yup
      .object()
      .shape({
        [CF.THIRD_PARTY_FTP_PROTOCOL.key]: yup.string().trim().optional(),
        [CF.THIRD_PARTY_FTP_HOST.key]: yup
          .string()
          .trim()
          .optional()
          .matches(HOST_REGEX, {
            message: 'Please provide a valid host',
            excludeEmptyString: true,
          }),
        [CF.THIRD_PARTY_FTP_PORT.key]: yup
          .string()
          .trim()
          .optional()
          .matches(NUMBER_REGEX, {
            message: 'Port must be a positive numerical value',
            excludeEmptyString: true,
          }),
        [CF.THIRD_PARTY_FTP_USERNAME.key]: yup.string().trim().optional(),
        [CF.THIRD_PARTY_FTP_PASSWORD.key]: yup.string().trim().optional(),
      })
      .optional(),

    //sms configuration
    [configRootFields.SMS]: yup.object().shape({
      [CF.SMS_URL.key]: yup
        .string()
        .trim()
        .required('SMS URL is a required field'),
      [CF.SMS_USERNAME.key]: yup
        .string()
        .trim()
        .required('SMS Username is a required field'),
      [CF.SMS_PASSWORD.key]: yup
        .string()
        .trim()
        .required('SMS password is a required field'),
      [CF.SMS_SENDER_ID.key]: yup
        .string()
        .trim()
        .required('SMS Sender Id is a required field'),
      [CF.SMS_MOBILE_NUMBERS.key]: yup
        .string()
        .trim()
        .required('SQL Mobile Numbers is a required field'),
    }),
    // SMS throttling (minutes) - optional; empty/absent falls back to backend default.
    [CF.SMS_THROTTLE_MINUTES.key]: yup
      .string()
      .trim()
      .matches(NUMBER_REGEX, {
        message: `${CF.SMS_THROTTLE_MINUTES.label} must be a positive whole number (minimum 1).`,
        excludeEmptyString: true,
      })
      .nullable()
      .optional(),
    [CF.SYNC_FAILURE_SMS_THROTTLE_MINUTES.key]: yup
      .string()
      .trim()
      .matches(NUMBER_REGEX, {
        message: `${CF.SYNC_FAILURE_SMS_THROTTLE_MINUTES.label} must be a positive whole number (minimum 1).`,
        excludeEmptyString: true,
      })
      .nullable()
      .optional(),

    // SAP inventory update window: both or neither, end after start
    [CF.SAP_INVENTORY_UPDATE_WINDOW_START.key]: yup
      .string()
      .optional()
      .test(
        'both-or-neither',
        'Set both start and end, or leave both blank',
        (value, { parent }) =>
          !value === !parent[CF.SAP_INVENTORY_UPDATE_WINDOW_END.key],
      ),
    [CF.SAP_INVENTORY_UPDATE_WINDOW_END.key]: yup
      .string()
      .optional()
      .test(
        'both-or-neither',
        'Set both start and end, or leave both blank',
        (value, { parent }) =>
          !value === !parent[CF.SAP_INVENTORY_UPDATE_WINDOW_START.key],
      )
      .test(
        'after-start',
        'End time must be after start time',
        (value, { parent }) => {
          const start = parent[CF.SAP_INVENTORY_UPDATE_WINDOW_START.key]
          return !value || !start || value > start
        },
      ),

    // Pharmacy
    [configRootFields.PHARMACY]: yup.object().shape({
      [CF.PHARMACY_ENABLE_3PL_IMPORT.key]: yup.boolean().default(false),
    }),
  })
  .required()

export const manualCronSchema = yup
  .object()
  .shape({
    lastUpdatedDateTime: yup
      .string()
      .trim()
      .required('Last Updated Date is a required field'),
  })
  .required()
